import React, { useState } from 'react';
import CommonModal from '../../../Components/CommonModal';
import CommonLoader from '../../../Components/CommonLoader';
import { risk_portal_update_kri } from '../../../services';

// KriForm — update an existing Key Risk Indicator's current value, thresholds
// and unit. CommonModal owns the form. KRIs are CREATED from a risk's detail
// view (they're bound to a risk), so this is edit-only. The page owns the toast;
// this reports via callbacks. Payload: { current_value, threshold_warning,
// threshold_breach, unit }.
//
// Props: show, kri (the row being edited), onClose, onSuccess(msg), onError(msg).
export default function KriForm({ show, kri, onClose, onSuccess, onError }) {
    const [busy, setBusy] = useState(false);
    if (!kri) return null;

    const num = (v) => (v === '' || v === null || v === undefined ? null : Number(v));

    const submit = async (data) => {
        setBusy(true);
        try {
            const payload = {
                name: kri.name,
                unit: (data.unit || '').trim(),
                current_value: num(data.current_value),
                threshold_warning: num(data.threshold_warning),
                threshold_breach: num(data.threshold_breach),
            };
            await risk_portal_update_kri(kri.id, payload);
            onSuccess?.(`KRI "${kri.name}" updated`);
            onClose?.();
        } catch (e) {
            onError?.(e?.response?.data?.error?.message || e?.response?.data?.response_data?.message || 'Failed to update KRI');
        } finally {
            setBusy(false);
        }
    };

    return (
        <CommonModal
            show={show}
            onHide={onClose}
            mid
            title={`Update KRI: ${kri.name}`}
            subtitle="Set the latest reading and the warning / breach thresholds."
            fields={[
                { name: 'current_value', label: 'Current Value', type: 'number', half: true, required: 'Current value is required.' },
                { name: 'unit', label: 'Unit', type: 'text', half: true, placeholder: 'e.g. %, days, count' },
                { name: 'threshold_warning', label: 'Warning Threshold', type: 'number', half: true },
                { name: 'threshold_breach', label: 'Breach Threshold', type: 'number', half: true },
            ]}
            defaultValues={{
                current_value: kri.current_value ?? '',
                unit: kri.unit ?? '',
                threshold_warning: kri.threshold_warning ?? '',
                threshold_breach: kri.threshold_breach ?? '',
            }}
            onSubmit={submit}
            buttons={[
                { text: 'Cancel', variant: 'secondary', onClick: onClose },
                { text: 'Update KRI', variant: 'primary', type: 'submit' },
            ]}
        >
            {busy && <CommonLoader overlay label="Saving…" />}
        </CommonModal>
    );
}
